export class UploadFileComponent {
    constructor(
        pathApi: string,
        private loader: HTMLElement | null
    ) {
        const uploadFile: HTMLFormElement | null = document.querySelector('[data-upload-file]');
        if (uploadFile) {
            uploadFile.addEventListener('submit', (e) => {
                e.preventDefault();
                this.download(uploadFile, pathApi);
            })
        }
    }
    download(uploadFile: HTMLFormElement, pathApi: string) {
        this.loader?.classList.add('active');
        const formData = new FormData(uploadFile);

        fetch(pathApi ?? '/api/admin/upload', {
            method: 'POST',
            headers: {
                'Authorization': 'true'
            },
            body: formData
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                this.loader?.classList.remove('active');

            })
            .catch(error => {
                this.loader?.classList.remove('active');
            });
    }
}
